"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePollAttendance = exports.useJoinSupportGroupChat = void 0;
var _react = require("react");
var _utils = require("../../utils");
var _ = require("./..");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// Frequency (ms) of recording attendance
var POLL_ATTENDANCE_INTERVAL = 60 * 1000;
var recordSessionAttendance = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(groupId) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _utils.apiWithoutErrorsHandler.post((0, _utils.getAttendGroupSessionUrl)(groupId)));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function recordSessionAttendance(_x) {
    return _ref.apply(this, arguments);
  };
}();

// Poll server once every POLL_ATTENDANCE_INTERVAL to record attendance
var usePollAttendance = function usePollAttendance(enabled, groupId) {
  var intervalRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!enabled) {
      return;
    }
    var pollAttendance = function pollAttendance() {
      intervalRef.current = setInterval(function () {
        recordSessionAttendance(groupId).catch(function () {
          clearInterval(intervalRef.current);
        });
      }, POLL_ATTENDANCE_INTERVAL);
    };
    recordSessionAttendance(groupId).then(pollAttendance).catch(function (error) {
      console.warn('Error recording session attendance', error);
    });
    return function () {
      return clearInterval(intervalRef.current);
    };
  }, [enabled]);
};
exports.usePollAttendance = usePollAttendance;
var joinSupportGroupChat = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(groupId, accountId) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _utils.apiWithoutErrorsHandler.post((0, _utils.getChannelMemberUrl)(groupId, accountId)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function joinSupportGroupChat(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var useJoinSupportGroupChat = function useJoinSupportGroupChat(chatClient, groupId) {
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    isMember = _useState2[0],
    setIsMember = _useState2[1];
  (0, _react.useEffect)(function () {
    var ensurePatientIsChannelMember = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$chatQueryServi, _yield$chatQueryServi2, channel, _isMember;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _utils.chatQueryService.queryChannels({
                  client: chatClient,
                  filter: {
                    id: groupId
                  }
                });
              case 3:
                _yield$chatQueryServi = _context3.sent;
                _yield$chatQueryServi2 = _slicedToArray(_yield$chatQueryServi, 1);
                channel = _yield$chatQueryServi2[0];
                _isMember = (0, _utils.isChannelMember)(channel);
                setIsMember(_isMember);
                if (_isMember) {
                  _context3.next = 12;
                  break;
                }
                _context3.next = 11;
                return joinSupportGroupChat(groupId, user.accountId);
              case 11:
                setIsMember(true);
              case 12:
                _context3.next = 17;
                break;
              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](0);
                _utils.toast.error({
                  title: 'Something went wrong',
                  description: 'Cannot join chat. Please try later'
                });
              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 14]]);
      }));
      return function ensurePatientIsChannelMember() {
        return _ref3.apply(this, arguments);
      };
    }();
    ensurePatientIsChannelMember();
  }, []);
  return {
    isMember: isMember
  };
};
exports.useJoinSupportGroupChat = useJoinSupportGroupChat;